<template>
  <rd-modal
      :show="show"
      @update:show="$emit('update:show', $event)"
      @close="$emit('initialize')"
  >
    <template #header>
      <slot name="header"></slot>
    </template>
    <template #body>
      <slot name="body"></slot>
    </template>
    <template v-if="$slots.footer" #footer>
      <slot name="footer"></slot>
    </template>
  </rd-modal>
</template>
<script>
import RdModal from '@/components/common/RdModal.vue'

/**
 * @component ModalPopup
 * @description 기존 사용처용 호환 래퍼 — 모달 틀은 RdModal 하나다(SURINP-693).
 * header / body / footer 슬롯과 update:show · initialize 이벤트를 그대로 유지하고 RdModal 에 넘긴다.
 * 모달별 너비는 사용처 scoped CSS 에서 `:deep(.modal-container) { width: ... }` 로 직접 지정합니다 (코드베이스 컨벤션).
 */
export default {
  components: { RdModal },
  // ── Props ──
  props: {
    /**
     * 모달 표시 여부 (v-model 바인딩용)
     * @type {boolean}
     */
    show: { type: Boolean }
  },
  emits: ['update:show', 'initialize'],
  // ── 메서드 ──
  methods: {
    /**
     * 모달을 닫고 초기화 이벤트를 부모에게 emit합니다.
     */
    closeModal() {
      this.$emit('update:show', false)
      this.$emit('initialize')
    }
  }
}
</script>
